import React, { useState } from 'react'

import styles from './Accordion.module.scss'

import { CaretDown as CaretIcon } from '../../../icons'

interface IAccordionProps {
  title: string
  children: React.ReactNode
  className?: string
  accordionContentClassName?: string
}

const Accordion: React.FC<IAccordionProps> = (props) => {
  const { title, children, className, accordionContentClassName } = props

  const [isAccordionActive, toggleAccordion] = useState(false)

  const handleToggle = () => toggleAccordion(!isAccordionActive)

  return (
    <div
      className={`
        ${styles.accordion}
        ${className || ''}
      `}
    >
      <button
        className={`
            ${styles.accordionToggle}
            ${isAccordionActive ? styles.active : ''}
          `}
        onClick={handleToggle}
      >
        <div className={styles.toggleContent}>
          <div className={styles.title}>{title}</div>
          <div className={styles.toggleIconWrapper}>
            <CaretIcon />
          </div>
        </div>
      </button>

      <div
        className={`
            ${styles.accordionContent}
            ${accordionContentClassName || ''}
            ${isAccordionActive ? styles.active : ''}
          `}
      >
        {children}
      </div>
    </div>
  )
}

export default Accordion
